var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73.3 81.5",
    style: {
      enableBackground: "new 0 0 73.3 81.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#4C54F3;}\n\t.st2{enable-background:new    ;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_985"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.1,30.2h-3l-7.9,19.3H25l2.2-5.6H36l2.2,5.6h2.7L33.1,30.2z M28,41.8l2.5-6.3c0.5-1.2,0.8-2.2,1-2.9 l0.1-0.4l0.4,1.1c0.2,0.8,0.5,1.5,0.8,2.1l2.5,6.4H28z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.3,
    y: 30.2,
    className: "st0",
    width: 2.6,
    height: 19.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.3,4.6h-68c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2h68c1.1,0,2-0.9,2-2v-68C72.3,5.5,71.4,4.6,70.3,4.6z  M69.3,73.6h-66v-66h66V73.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,4.6h-68c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2h68c1.1,0,2-0.9,2-2v-68C72.3,5.5,71.4,4.6,70.3,4.6z  M69.3,73.6h-66v-66h66V73.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.1,30.2h-3l-7.9,19.3H25l2.2-5.6H36l2.2,5.6h2.7L33.1,30.2z M28,41.8l2.5-6.3c0.5-1.2,0.8-2.2,1-2.9 l0.1-0.4l0.4,1.1c0.2,0.8,0.5,1.5,0.8,2.1l2.5,6.4H28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.3,30.2v19.3h2.6V30.2H44.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.1,30.2h-3l-7.9,19.3H25l2.2-5.6H36l2.2,5.6h2.7L33.1,30.2z M28,41.8l2.5-6.3c0.5-1.2,0.8-2.2,1-2.9 l0.1-0.4l0.4,1.1c0.2,0.8,0.5,1.5,0.8,2.1l2.5,6.4H28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.3,30.2v19.3h2.6V30.2H44.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAi);
export default __webpack_public_path__ + "static/media/_icon_AI.bdf2c6a45a5f94d3abaa5067741e988c.svg";
export { ForwardRef as ReactComponent };